<template>
  <div class="progress-bar-wrapper" v-if="!hideProgressBar">
    <div class="step-progress-bar">
      <div class="step" v-for="(step, i) in overallSteps" :key="i">
        <div :class="getClasses(i)">
          <div class="inner-circle"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventBus from '@/EventBus'

export default {
  name: 'ProgressBar',
  props: {
    currentStep: Number,
    overallSteps: {
      type: Number,
      default: 4,
    },
  },
  data() {
    return {
      showProgressBar: true,
    }
  },
  created() {
    EventBus.$on('toggle-progress-bar-display', (data) => {
      this.showProgressBar = data
    })
  },
  methods: {
    getClasses(i) {
      return {
        bullet: i + 1 !== this.overallSteps,
        current: i + 1 === this.currentStep,
        'last-bullet': i + 1 === this.overallSteps,
        completed: i + 1 < this.currentStep,
      }
    },
  },
  computed: {
    ...mapState('transaction', ['showBodyOnly']),
    hideProgressBar() {
      return this.showBodyOnly || !this.showProgressBar
    },
  },
}
</script>

<style scoped lang="scss">
.step-progress-bar {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  width: 180px;
  margin: 0 auto;
  padding-top: 48px;

  @media screen and (max-width: $mobile-resolution) {
    padding-top: 24px;
  }

  & .bullet {
    height: 16px;
    width: 16px;
    border-radius: 100%;
    border: 1px solid #299cd1;
    display: inline-block;
    position: relative;

    &::after {
      content: '';
      position: absolute;
      right: -37px;
      bottom: 7px;
      height: 1px;
      width: 32px;
      background-color: #d8d8d8;
    }

    &.completed::after {
      content: '';
      background-color: #299cd1;
    }
  }

  & .last-bullet {
    height: 16px;
    width: 16px;
    border-radius: 100%;
    border: 1px solid #299cd1;
    display: inline-block;
    position: relative;

    &.completed::after {
      content: '';
      background-color: #299cd1;
    }
  }
}

.step {
  text-align: center;
}

.step-text {
  margin-bottom: 8px;
  color: #299cd1;
}

.completed {
  .inner-circle {
    position: relative;
    height: 10px;
    width: 10px;
    border-radius: 100%;
    background: #299cd1;
    margin: 2px;
  }
}

.current {
  .inner-circle {
    position: relative;
    height: 10px;
    width: 10px;
    border-radius: 100%;
    background: #fcc700;
    margin: 2px;
  }
}
</style>
